/** @format */

import React from "react";
import { Card, Spin } from "antd";

const LoadingCard = (props) => {
  const { loading, heightSize } = props;
  return (
    <Card
      loading={loading}
      style={{
        height: heightSize,
        width: "100%",
      }}
    />
  );
};

export default LoadingCard;
